import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';

let allRoutes = [];
let router;
if (typeof VUE_PROJECT_NAME === 'undefined' || VUE_PROJECT_NAME === 'recruiterBridge') {
    router = {
        addRoute: () => {}
    };
} else {
    router = createRouter({
        history: createWebHashHistory(),
        routes: []
    });
}

let defaultAddRoute = router.addRoute;
router.addRoute = function addRoute(route) {
    if (allRoutes.indexOf(route.path) === -1) {
        allRoutes.push(route.path);
    }
    defaultAddRoute.call(this, route);
};

router.addRoutes = function addRoutes(routes) {
    for (let i in routes) {
        if (i === 'length') continue;
        router.addRoute(routes[i]);
    }
};

router.allRoutes = allRoutes;
window['router'] = router;
export { router };
